import { Box, NumberFormatter, Stack, Text } from '@mantine/core';

import { NavLink } from 'react-router-dom';

const ActivationCostCell = ({ cell }) => {
    const { column, row } = cell;
    const rowData = row.original;
    return (
        <Box
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '16px',
            }}>
            <Text ta={'center'}>
                <NumberFormatter
                    value={rowData.activationCost}
                    prefix={'$'}
                    decimalScale={2}
                    fixedDecimalScale={true}
                />
            </Text>
        </Box>
    );
};

const ActivationCostColumn = () => ({
    accessorKey: 'activationCost',
    header: 'Activation Cost',
    size: 1,
    Cell: ({ cell }) => <ActivationCostCell cell={cell} />,
});
export default ActivationCostColumn;
